const app = {
  routerName: {
    login: 'login',
    signup: 'signup',
    resetPassword: 'resetPassword',
    verifyEmail: 'verifyEmail',
    verifyEmailWithId: 'verifyEmailWithId',
    resetPasswordWithId: 'resetPassword-id',
    rejectedPage: 'rejectedPage',
    registration: 'registration',
    dealerType: 'dealerType',
    dealerInfo: 'dealerInfo',
    picInfo: 'picInfo',
    supportDocs: 'supportDocs',
    termsOfPayment: 'termsOfPayment',
    termsAndCondition: 'termsAndCondition',
    homePage: 'homePage',
    landingPage: 'landingPage',
    orderList: 'order',
    catalog: 'catalog',
    rewards: 'rewards',
    orderDetail: 'orderDetail',
    orders: 'orders',
    notification: 'notification',
    checkout: 'checkout',
    thankyouPage: 'thankyouPage',
    tenantPicker: 'tenantPicker',
    profile: 'profile',
    mission: 'mission',
    missionDetail: 'missionDetail',
    creditNote: 'creditNote',
    rewardsDetail: 'rewardsDetail'
  }
}
const pages = {
  landingPage: '/',
  homePage: '/home',
  login: '/login',
  signup: '/signup',
  resetPassword: '/reset-password',
  verifyEmail: '/verify-email',
  verifyEmailWithId: '/verify-email/:id',
  rejectedPage: '/rejected-page',
  registration: '/registration',
  dealerType: 'dealer-type',
  dealerInfo: 'dealer-info',
  picInfo: 'pic-info',
  supportDocs: 'support-docs',
  termsOfPayment: 'top',
  termsAndCondition: '/tnc',
  orderList: '/orderList',
  catalog: '/catalog',
  rewards: '/imeiScan',
  rewardsDetail: '/imeiScan/:id',
  orderDetail: '/order/:orderId',
  notification: '/notification',
  checkout: '/checkout',
  thankyouPage: '/thank-you/:orderId',
  tenantPicker: '/tenant-picker',
  profile: '/profile',
  mission: '/mission',
  missionDetail: '/mission/:missionId',
  creditNote: '/credit-note'
}

const api = {
  auth: {
    sessionUpdate: '/omg-member/api/session/update',
    userDetails: '/omg-member/api/login/user',
    login: '/omg-member/api/login',
    logout: '/omg-member/api/login/destroy',
    signup: '/omg-member/api/login/sign-up',
    verifyEmailWithId: '/omg-member/api/login/verify-mail',
    forgotPassword: '/omg-member/api/login/forgot-password',
    resetPassword: '/omg-member/api/login/reset-password',
    verifyPasswordWithId: '/omg-member/api/login/verify-password-link',
    sendVerificationEmail: '/omg-member/api/login/send-verification-mail',
    switchCompany: '/omg-member/api/company-switch',
    switchTheme: '/omg-member/api/preferences/updateTheme',
    updateNickName: '/omg-member/api/member/updateChildNickName'
  },
  agreement: {
    pending: '/omg-member/api/agreement/pending',
    respond: '/omg-member/api/agreement/respond'
  },
  registration: {
    fileUpload: '/omg-member/api/register/upload',
    postRegisterData: '/omg-member/api/register/v2/newUser',
    registrationType: '/omg-member/api/register/v2/updateRegistrationType',
    getUserRegistrationDetails: '/omg-member/api/register/v2/getUserRegistrationDetails',
    getCategoryAndDepo: '/omg-member/api/dealerData/getCategoryAndDepo',
    getAllProvince: '/omg-member/api/xRegion/getAllProvince',
    getCitiesByProvince: '/omg-member/api/xRegion/getCitiesByProvince',
    getDistrictByCityCode: '/omg-member/api/xRegion/getDistrictByCityCode',
    getSubDistrictByDistrictCode: '/omg-member/api/xRegion/getSubDistrictByDistrictCode',
    getPostalCodeBySubDistrictCode: '/omg-member/api/xRegion/getPostalCodeBySubDistrictCode',
    markUserLogout: '/omg-member/api/register/v2/userLogOut',
    completeRegistrationProcess: '/omg-member/api/register/v2/saveRegistration',
    firstLoginPostApproval: '/omg-member/api/register/v2/firstLoginPostApproval',
    getAvailableTenants: '/omg-member/api/tenant/getAvailableTenants',
    getTenantDistributorInfo: '/omg-member/api/tenant/getTenantDistributorInfo',
    getAccountRegistrationSummary: '/omg-member/api/register/getAccountRegistrationSummary'
  },
  cmsConfig: {
    getConfig: '/config/get/',
    getServiceAndPromotion: '/backend/content/pages/omg/sections?display=normal'
  },
  cart: {
    getAvailableTermsOfPayment: '/omg-cart/api/cart/getAvailableTermsOfPayment',
    dealerPurchaseReport: '/omg-cart/api/cart/download/dealerPurchaseReport',
    getCartItems: '/omg-cart/api/cart/getCartItems',
    addToCart: '/omg-cart/api/cart/addToCart',
    createQuotation: '/omg-cart/api/quotation/createQuotation'
  },
  product: {
    getAllCategories: '/omg-product/api/catalogue/getAllValue',
    getAllProducts: '/omg-product/api/product/getAllValue',
    getProductDetails: '/omg-product/api/product/getValue'
  },
  rewards: {
    scannedProductList: '/omg-engagement/api/reward-point/scanned-products-list',
    addScannedProduct: '/omg-engagement/api/reward-point/scan',
    downloadProducts: '/omg-engagement/api/reward-point/download-scanned-info',
    uploadProducts: '/omg-engagement/api/reward-point/upload-scanned-info-pwa',
    getEngagementInfo: '/omg-engagement/api/engagement/getEngagementInfo',
    pointsHistory: '/omg-engagement/api/loyalty/history',
    getScannedProductDetail: '/omg-engagement/api/reward-point/get-scanned-product',
    uploadInvoice: '/omg-engagement/api/cashback/claim-cashback',
    listGift: '/omg-engagement/api/gift/findActiveGifts',
    redeemGift: '/omg-engagement/api/giftRedemption/redeem',
    getRedeemedGiftDetails: '/omg-engagement/api/giftRedemption/giftDetail',
    getRedeemedHistory: '/omg-engagement/api/giftRedemption/history',
    getDashboardInfo: '/omg-engagement/api/reward-point/dashboard-info-pwa'
  },
  banner: {
    getAllBanners: '/omg-engagement/api/banner/getAllBanners'
  },
  order: {
    getOrderList: '/omg-cart/api/quotation/getQuotationHistory',
    getOrderDetail: '/omg-cart/api/quotation/getQuotationDetails',
    processQuotation: '/omg-cart/api/quotation/processQuotation',
    createOtp: '/omg-cart/api/otp/create',
    validateOtp: '/omg-cart/api/otp/verify',
    preCheckOtp: '/omg-cart/api/otp/preCheck'
  },
  nps: {
    saveNpsFeedback: '/omg-engagement/api/feedback/saveNps',
    cancelNpsFeedback: '/omg-engagement/api/feedback/cancelNps'
  },
  mission: {
    getMissionList: '/omg-engagement/api/mission/getMissionLists',
    getMissionDetail: '/omg-engagement/api/mission/getDealerDetails'
  },
  creditNote: {
    getCreditNoteCount: '/omg-cart/api/credit-note-program-detail/credit-note-count',
    getAvailableCreditNote: '/omg-cart/api/credit-note-claim/available-credit-note-list',
    downloadCreditNotePdf: '/omg-cart/api/credit-note-claim/dealer/download-credit-note-pdf',
    getAvailableQuotation: '/omg-cart/api/credit-note-claim/available-quotations',
    createClaimRequest: '/omg-cart/api/credit-note-claim/create-claim',
    requestActivation: '/omg-cart/api/credit-note-claim/request-activation',
    uploadFile: '/omg-cart/api/credit-note-claim/upload-credit-note-document'
  },
  notification: {
    saveToken: '/omg-engagement/api/appleReseller/notification/token',
    deleteToken: '/omg-engagement/api/appleReseller/notification/token',
    updateTime: '/omg-engagement/api/appleReseller/notification/updateTokenTime',
    getNotifications: '/omg-engagement/api/appleReseller/notification/in-app',
    markAsRead: '/omg-engagement/api/appleReseller/notification/in-app/markAsRead'
  }
}

export { app, pages, api }
